import { TaskLibrary } from '@types'

import { Select, Option } from '@components/Select'

import { useTaskLibraries } from '@hooks/task-library/task-libraries.hook'

interface Props {
  autoFocus?: boolean
  required?: boolean
  taskName: string
  onChangeTask: (name: string, task?: TaskLibrary) => void
  label: string
  placeholder: string
  refInput?: (ref: HTMLInputElement | null) => void
}

export const SelectTaskLibrary = (props: Props): JSX.Element => {
  const { autoFocus, required, taskName, onChangeTask, label, placeholder, refInput } = props

  const { data } = useTaskLibraries()

  const options: Option[] = (data?.taskLibraries || [])
    .map((task) => ({
      id: task.id,
      label: task.name,
      data: task,
    }))
    .filter((option) => option.label.toLowerCase().indexOf(taskName.toLowerCase()) != -1)

  return (
    <Select
      disabledVerticalCorrection
      preventDropDownOnAutofocus
      refInput={refInput}
      autoFocus={autoFocus}
      required={required}
      label={label}
      placeholder={placeholder}
      search={taskName}
      onSearch={(value) => {
        onChangeTask(value)
      }}
      options={options}
      onClick={(option) => {
        if (option) {
          onChangeTask(option.label, option.data as TaskLibrary)
        }
      }}
    />
  )
}
